import { makeCRUDSlice } from '@redux/crudCreator';
import {
  editInvoiceInformation,
  MODEL_NAME,
  ordersTabTryBuyActions,
} from './actions';
import { PRIMARY_KEY } from '@redux/crudCreator/dataProvider';
import _, { omit } from 'lodash';

export const editInformationSuccess = (
  state,
  { payload: { data, options } },
) => {
  state.loading = false;
  state.error = null;
  if (!options?.skipSave) {
    state.data[data[PRIMARY_KEY]] = {
      ...state.data[data[PRIMARY_KEY]],
      ...data,
    };
    state.currentData = { ...state.currentData, ...data };
  }

  if (options?.hasGetAllAfterEdit) {
    state.ids = _.xor(state.ids, [data[PRIMARY_KEY]]);
  }

  state.rollbackData = omit(state.rollbackData, [data.id]);
  state.itemLoadings = { ...state.itemLoadings, [data[PRIMARY_KEY]]: false };
};

export const editInformationFailure = (state, { payload: { data } }) => {
  state.loading = false;
  state.error = data;
  state.data = {
    ...state.data,
    [data[PRIMARY_KEY]]: state.rollbackData[data[PRIMARY_KEY]],
  };
  state.rollbackData = omit(state.rollbackData, [data.id]);
  state.itemLoadings = { ...state.itemLoadings, [data[PRIMARY_KEY]]: false };
};

const slice = makeCRUDSlice(MODEL_NAME, ordersTabTryBuyActions, {
  [editInvoiceInformation.fulfilled as any]: editInformationSuccess,
  [editInvoiceInformation.rejected as any]: editInformationFailure,
});

export default slice.reducer;
